import {Animal, Color} from "./animals";

export interface CommentSectionProps {
    slug: string;
}

// Data as received from the server
export interface CommentData {
    animal: Animal;
    authorId: string;
    authorName: string;
    color: Color;
    date: string;
    isApproved: boolean;
    isEdited: boolean;
    message: string;
    replies: string[];
}

export interface CommentContextProps {
    collapsedComments: Map<string, boolean>;
    parentId: string;
    toggleCollapse: (commentId: string) => void;
    slug: string;
    isAdmin: boolean;
    animal: Animal;
    color: Color;
    authorName: string;
    setAuthorName: (name: string) => void;
    setAnimal: (animal: Animal) => void;
    setColor: (color: Color) => void;
}

// Data as used internally to store all comment properties
export interface CommentProps extends CommentData {
    canCancel: boolean;
    commentId: string;
    context: CommentContextProps;
    depth: number;
    isEditable: boolean;
    isDeleted: boolean;
    isOwned: boolean;
    isReply: boolean;
}

// Data as sent to the server
export interface SendCommentData  {
    animal: Animal;
    authorId: string;
    authorName: string;
    authorSecret: string;
    color: Color;
    commentId: string;
    message: string;
    parentId: string;
    recaptcha: string;
    slug: string;
}


export interface Setters {
    color: (color: Color) => void,
    animal: (animal: Animal) => void,
    authorName: (author: string) => void,
    message: (message: string) => void,
    isReplying: (state: boolean) => void,
    replyToggle: () => void,
    isCustomizing: (state: boolean) => void,
    customizingToggle: () => void,
    isDeleted: (state: boolean) => void,
    setDeleted: () => void,
    editState: (state: boolean) => void,
    editToggle: () => void,
}

export const SettersDefault: Setters = {
    color: () => {},
    animal: () => {},
    authorName: () => {},
    message: () => {},
    isReplying: () => {},
    replyToggle: () => {},
    isCustomizing: () => {},
    customizingToggle: () => {},
    isDeleted: () => {},
    setDeleted: () => {},
    editState: () =>  {},
    editToggle: () => {},
};


